import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { api } from "@/lib/api";

export function PlanBanner() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/admin/plan").then((r) => setP(r.data)).catch(() => {}); }, []);
  if (!p) return null;
  const days = p.key === "trial" && p.trial_ends_at ? Math.max(0, Math.ceil((new Date(p.trial_ends_at) - Date.now()) / 864e5)) : null;
  const full = p.tours != null && p.used >= p.tours;
  if (p.key !== "trial" && !full) return null;
  return (
    <div className={`mb-6 rounded-2xl px-5 py-3 text-sm flex flex-wrap items-center gap-3 ${full ? "bg-rose-50 text-rose-900" : "bg-amber-50 text-amber-900"}`} data-testid="plan-banner">
      <Sparkles className="w-4 h-4" />
      <span className="font-semibold">{p.name}{days != null ? ` · ${days} day${days === 1 ? "" : "s"} left` : ""}</span>
      <span data-testid="plan-usage">{p.used} of {p.tours ?? "unlimited"} tour{p.tours === 1 ? "" : "s"} used{p.ai_chats ? ` · ${p.ai_used} of ${p.ai_chats.toLocaleString()} AI chats ${p.key === "trial" ? "in your trial" : "this month"}` : ""}</span>
      <a href="/#pricing" target="_blank" rel="noreferrer" className="ml-auto h-8 px-4 rounded-full bg-slate-900 text-white text-xs font-semibold inline-flex items-center" data-testid="plan-upgrade">Choose a plan</a>
    </div>
  );
}
